import React, { useContext, useEffect, useState } from "react";
import useFetch from "../Hooks/useFetch";
import useDelete from "../Hooks/useDelete";
import useSave from "../Hooks/useSave";
import useUpdate from "../Hooks/useUpdate";
import { categoriesURL } from "../Hooks/URL";
import { useParams, useNavigate } from "react-router-dom";
import { userContext } from "../Contexts/userContext";
import CategoryDetails from "../Templates/Home/Categories/CategoryDetails/CategoryDetails";
import DeleteForm from "../Components/Molecules/DeleteForm/DeleteForm";
import { Fetch } from "../Hooks/Fetch";

function CategoryDetailsPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  let { id } = useParams();

  const url = `${categoriesURL}/${id}`;
  const ageGroupsUrl = `${url}/age-groups`;

  const [category, setCategory] = useState({});
  const [ageGroups, setAgeGroups] = useState([]);
  const [goDelete, setGoDelete] = useState(false);
  const [goSaveAgeGroup, setGoSaveAgeGroup] = useState(false);
  const [goUpdateAgeGroup, setGoUpdateAgeGroup] = useState(false);
  const [goDeleteAgeGroup, setGoDeleteAgeGroup] = useState(false);
  const [ageGroupData, setAgeGroupData] = useState({});
  const [editingAgeGroupId, setEditingAgeGroupId] = useState(null);
  const [deletingAgeGroupId, setDeletingAgeGroupId] = useState(null);
  const [goUpdateActive, setGoUpdateActive] = useState(false);
  const [activeStatusData, setActiveStatusData] = useState({});

  const { data, loading, error } = useFetch(url);
  const {
    data: ageGroupsData,
    loading: ageGroupsLoading,
    error: ageGroupsError,
  } = useFetch(ageGroupsUrl);

  const { state: deleteState, loading: deleteLoading } = useDelete(
    url,
    goDelete,
    "categories"
  );

  const { saveState: saveAgeGroupState, loading: saveAgeGroupLoading } =
    useSave({
      url: ageGroupsUrl,
      goSave: goSaveAgeGroup,
      setGoSave: setGoSaveAgeGroup,
      newObject: ageGroupData,
      setNewData: {
        function: (data) => {
          setAgeGroups(data);
        },
      },
      FetchUrl: ageGroupsUrl,
    });

  const { state: updateAgeGroupState, loading: updateAgeGroupLoading } =
    useUpdate(
      editingAgeGroupId ? `${ageGroupsUrl}/${editingAgeGroupId}` : null,
      goUpdateAgeGroup,
      setGoUpdateAgeGroup,
      ageGroupData,
      null
    );

  const { state: deleteAgeGroupState, loading: deleteAgeGroupLoading } =
    useDelete(
      deletingAgeGroupId ? `${ageGroupsUrl}/${deletingAgeGroupId}` : null,
      goDeleteAgeGroup,
      null,
      {
        function: (data) => {
          setAgeGroups(data);
        },
      },
      ageGroupsUrl
    );

  const { state: updateActiveState, loading: updateActiveLoading } = useUpdate(
    url,
    goUpdateActive,
    setGoUpdateActive,
    activeStatusData,
    null
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setCategory(data.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!ageGroupsLoading && !ageGroupsError && ageGroupsData) {
      setAgeGroups(ageGroupsData.data);
    }
  }, [ageGroupsData, ageGroupsLoading, ageGroupsError]);

  // Refresh age groups after save
  useEffect(() => {
    if (
      saveAgeGroupState?.dataRes?.status == "success" &&
      !saveAgeGroupLoading
    ) {
      Fetch(ageGroupsUrl, {
        function: setAgeGroups,
      });
    }
  }, [saveAgeGroupState]);

  // Refresh age groups after update
  useEffect(() => {
    if (
      updateAgeGroupState?.dataRes?.status == "success" &&
      !updateAgeGroupLoading
    ) {
      Fetch(ageGroupsUrl, {
        function: setAgeGroups,
      });
      setEditingAgeGroupId(null);
    }
  }, [updateAgeGroupState]);

  // Refresh age groups after delete
  useEffect(() => {
    if (
      deleteAgeGroupState?.dataRes?.status == "success" &&
      !deleteAgeGroupLoading
    ) {
      Fetch(ageGroupsUrl, {
        function: setAgeGroups,
      });
      setDeletingAgeGroupId(null);
    }
  }, [deleteAgeGroupState]);

  // Refresh category after active status update
  useEffect(() => {
    if (
      updateActiveState?.dataRes?.status == "success" &&
      !updateActiveLoading
    ) {
      Fetch(url, {
        function: setCategory,
      });
    }
  }, [updateActiveState]);

  const handleAddAgeGroup = (formData) => {
    setAgeGroupData(formData);
    setGoSaveAgeGroup(true);
  };

  const handleUpdateAgeGroup = (formData) => {
    setAgeGroupData(formData);
    setGoUpdateAgeGroup(true);
  };

  const handleDeleteAgeGroup = (ageGroupId) => {
    setDeletingAgeGroupId(ageGroupId);
    setGoDeleteAgeGroup(true);
  };

  const handleToggleActive = () => {
    setActiveStatusData({ active: !category.active });
    setGoUpdateActive(true);
  };

  return (
    <CategoryDetails
      category={category}
      ageGroups={ageGroups}
      role={contextData?.role}
      url={url}
      loading={loading}
      ageGroupsLoading={ageGroupsLoading}
      categoryId={id}
      setGoDelete={setGoDelete}
      onAddAgeGroup={handleAddAgeGroup}
      onUpdateAgeGroup={handleUpdateAgeGroup}
      onDeleteAgeGroup={handleDeleteAgeGroup}
      editingAgeGroupId={editingAgeGroupId}
      setEditingAgeGroupId={setEditingAgeGroupId}
      saveAgeGroupLoading={saveAgeGroupLoading}
      updateAgeGroupLoading={updateAgeGroupLoading}
      onToggleActive={handleToggleActive}
      updateActiveLoading={updateActiveLoading}
    />
  );
}

export default CategoryDetailsPage;
